<div class="header-configuration">
  <h2>{{ title }}</h2>
  <p>
    {{ description }}
  </p>
</div>
